import { t } from "i18next";

export class ErrorUtils {
    public static ProcessSelectSolutionErrors(errors: string[]): string {
        let ret = "";

        errors.forEach((error) => {
            const regex = /\[(.*?)\]\[(.*?)\]\[(.*?)\] (.+)/;
            const match = regex.exec(error);
            let errorLine = "";

            errorLine = match ? match[3] : error;

            if (ret.includes(t(errorLine)) === false) {
                if (ret.length > 0) {
                    ret += "\n";
                }

                ret += t(errorLine);
            }
        });

        return (ret);
    }
}